import * as React from "react";
import Svg from "./StyledSvg";
type Props = {
  size?: "XS" | "S" | "M" | "L" | "XL" | "XXL";
  color?: string;
  style?: object;
};

interface SizeData {
    size: number;
    stroke: number;
  }

  interface AvailableSizes {
    XS: SizeData;
    S: SizeData;
    M: SizeData;
    L: SizeData;
    XL: SizeData;
    XXL: SizeData;
  }
  ;
const availableSizes: AvailableSizes = {"XS":{"size":16,"stroke":1.3},"S":{"size":20,"stroke":1.5},"M":{"size":24,"stroke":1.8},"L":{"size":40,"stroke":2.2},"XL":{"size":48,"stroke":2.5},"XXL":{"size":70,"stroke":2.8}};
function UserShield({
  size = "M",
  color = "currentColor",
  style
}: Props): React.JSX.Element {
  const strokeWidth = availableSizes[size]?.stroke;
  const appliedSize = availableSizes[size]?.size;
  return <Svg width={appliedSize} height={appliedSize} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" color={color} style={style}><path vectorEffect="non-scaling-stroke" d="M11.343 16C9.193 16 7.143 16.85 5.633 18.36M21 12C21 7.02 16.97 3 12 3C7.02 3 3 7.02 3 12C3 16.97 7.02 21 12 21M15 16.45V17.29H14.999C14.989 18.85 15.959 20.25 17.429 20.8L17.859 20.96C17.939 20.99 18.029 20.99 18.119 20.96L18.549 20.79C20.009 20.24 20.979 18.84 20.979 17.27V16.42C20.979 16.09 20.759 15.8 20.449 15.7L18.199 14.99C18.049 14.94 17.889 14.94 17.749 14.99L15.499 15.69C15.179 15.78 14.969 16.07 14.969 16.4L15 16.45ZM15 9.75V10.25C15 11.9 13.65 13.25 12 13.25C10.34 13.25 9 11.9 9 10.25V9.75C9 8.09 10.34 6.75 12 6.75C13.65 6.75 15 8.09 15 9.75Z" stroke="currentColor" strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round" /></Svg>;
}
export default UserShield;